import { render, staticRenderFns } from "./m-admin-snake-game.vue?vue&type=template&id=117bf3e2&scoped=true&"
import script from "./m-admin-snake-game.vue?vue&type=script&lang=js&"
export * from "./m-admin-snake-game.vue?vue&type=script&lang=js&"
import style0 from "./m-admin-snake-game.vue?vue&type=style&index=0&id=117bf3e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117bf3e2",
  null
  
)

export default component.exports